<template>
  <svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M21.63 11.815c0 5.42-4.394 9.815-9.815 9.815C6.395 21.63 2 17.236 2 11.815 2 6.395 6.394 2 11.815 2c5.42 0 9.815 4.394 9.815 9.815"
        stroke="#FFF" stroke-width="3" fill="#EF4B3F" />
      <path
        d="M10.053 10.808a1.51 1.51 0 1 1-3.02 0 1.51 1.51 0 0 1 3.02 0M13.577 10.808a1.51 1.51 0 1 0 3.02 0 1.51 1.51 0 0 0-3.02 0M14.643 16.848a.447.447 0 0 1-.376-.201c-.033-.051-.806-1.2-2.326-1.2-1.504 0-2.322 1.194-2.33 1.206a.451.451 0 0 1-.615.125.425.425 0 0 1-.129-.597c.044-.066 1.095-1.598 3.074-1.598 2.024 0 3.036 1.54 3.078 1.605a.425.425 0 0 1-.141.595.451.451 0 0 1-.235.065"
        fill="#000" />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmoticonFace1'
})
</script>
